// extracted by mini-css-extract-plugin
export var chevronIcon = "_d0-2";
export var teamName = "_d0-1";
export var teamSwitcherButton = "_d0-0";